import React from 'react';
import getThumbnailPhotoUrlFromHash from '../../lib/getThumbnailPhotoUrlFromHash';
import styles from './index.sass';

class StoreCard extends React.Component {
  static propTypes = {
    store: React.PropTypes.object
  };

  render() {
    let {store} = this.props;
    let backgroundPhotoProps = {
      className: styles.backgroundPhoto,
      style: {
        backgroundImage: `url(${getThumbnailPhotoUrlFromHash(store.background_photo_hash, 600)})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center'
      }
    };
    let marketingMessage = store.marketing_message;
    if(marketingMessage && marketingMessage.length > 90) {
      marketingMessage = marketingMessage.slice(0,90).concat('...');
    }
    let storeCardProps = {
      className: styles.storeCard,
      href: store.url,
      itemType: "http://schema.org/Organization"
    };
    let jsonLD = {
      "@context": "http://schema.org",
      "@type": "Organization",
      "email": store.contact_email,
      "telephone": store.phone_pretty,
      "url": store.about_url
    };
    if(store.background_photo_hash) {
      jsonLD.image = store.background_photo_hash.url;
    }
    if(store.logo_photo_hash) {
      jsonLD.logo = store.logo_photo_hash.url;
    }

    let address = store.address;
    if(address) {
      jsonLD.address = {
        "@type": "PostalAddress",
        "addressLocality": `${address.city}, ${address.state}, United States`,
        "postalCode": address.zip_code,
        "streetAddress": `${address.addr1}`
      };
      if(address.addr2) {
        jsonLD.address.streetAddress += ` ${address.addr2}`;
      }
    }
    return (
      <a itemScope {...storeCardProps}>
        <div {...backgroundPhotoProps} />
        <div className={styles.hoverOverlay} />
        <div className={styles.details}>
          <p className={styles.name} itemProp="name">{store.name}</p>
          <p className={styles.marketingMessage} itemProp="description">{marketingMessage}</p>
          <p className={styles.location}>{store.location}</p>
        </div>
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLD)}} />
      </a>
    );
  }
}

export default StoreCard;



// WEBPACK FOOTER //
// banquet/components/StoreCard/index.js